query GetProductEligibility($ids: [String]) {
    Products(where: { id: { in: $ids } }) {
        docs {
            id
            productType {
                eligibleForWindowDecoration
                eligibleForSunProtection
            }
        }
    }
}
